'use client'

import { FC } from 'react'
import useI18n from 'Hooks/useI18n'

const GemRewardDisplay: FC = () => {
  const { t } = useI18n()

  return (
    <div className="flex items-center justify-center gap-1">
      <span
        style={{
          fontSize: '11px',
          fontWeight: '500',
          color: '#FFCF5F',
          lineHeight: '17px',
        }}
      >
        {t('Up to')}
      </span>
      <span
        style={{
          width: '70px',
          textAlign: 'center',
          fontSize: '18px',
          fontWeight: '900',
          color: '#FFFFFF',
          lineHeight: '24px',
          fontStyle: 'italic',
          margin: '2px 0',
        }}
      >
        50,000
      </span>
      <span
        style={{
          fontSize: '11px',
          fontWeight: '500',
          color: '#FFCF5F',
          lineHeight: '17px',
        }}
      >
        {t('gems')}
      </span>
    </div>
  )
}

export default GemRewardDisplay
